<template>
    <div class="cart-item-view">
        <div class="cart-checkbox">
            <van-checkbox class="checkbox" @change="onCheckedChange" v-model="isChecked" checked-color="#07c160"></van-checkbox>
            <span></span>
        </div>
        <div class="cart-img">
            <img :src="cart.img" alt="">
            <span></span>
        </div>
        <div class="cart-detail">
            <div class="goods-detail">
                <span>特價</span>
                <span>{{cart.name}}</span>
            </div>
            <p>$ {{cart.price}}</p>
            <p>X{{cart.num}}</p>
        </div>
    </div>
</template>

<script>
    import { Checkbox } from 'vant';
    export default {
        name: 'CartItemView',
        props: ['cart', 'isChecked'],
        components: {
            [Checkbox.name]: Checkbox,
        },
        data() {
            return {
                checked: true
            };
        },
        created() {
            this.checked = this.isChecked
        },
        methods: {
            onCheckedChange: function () {
                // console.log(this.checked)
                this.$emit('onChangeChecked', this.checked, this.index)
            }
        }
    }
</script>

<style lang='scss'>
    .cart-item-view {
        margin: 10px;
        padding: 20px 5px;
        border: 1px solid #bbb;
        box-shadow: 0 0 4px 0 gray;
        border-radius: 5px;
        background-color: #fff;
        .cart-checkbox {
            padding: 10px 5px;
            height: 100%;
            display: inline-block;
            .checkbox {
                display: inline-block;
                vertical-align: middle;
                text-align: center;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                height: 100%;
                width: 0;
            }
        }
        .cart-img {
            height: 100%;
            display: inline-block;
            img {
                display: inline-block;
                vertical-align: middle;
                height: 70px;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                height: 100%;
                width: 0;
            }
        }
        .cart-detail {
            height: 100%;
            vertical-align: middle;
            display: inline-block;
            span:nth-of-type(1) {
                color: red;
                font-size: 14px;
                padding-right: 10px;
            }
            p {
                font-size: 13px;
            }
            p:nth-of-type(1) {
                line-height: 35px;
            }
        }
    }
</style>